import { appointmentApiHostName } from "../../endpoint";
import { defaultHeaders } from "../../headers";
import moment from "moment";
import { getOnlyTime, isPast, getTime } from "../../../utils/date";

export const getAppointmentList = async () => {
  try {
    const result = await fetch(`${appointmentApiHostName}`, {
      method: "GET",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json()
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message
    };
  }
};

const getAppointmentStatus = ({ isCancelled, isMissed }, isPastEvent) => {
  if (isCancelled) return "Cancelled";
  if (isMissed) return "Missed";
  if (!isMissed && isPastEvent) return "Completed";
  return "Booked";
};

const getInviteeName = (appointment) => {
  // New format: use invitees array
  if (appointment.invitees && appointment.invitees.length > 0) {
    if (appointment.invitees.length === 1) {
      const inv = appointment.invitees[0];
      return `${inv.firstName} ${inv.lastName}`;
    }
    // Multiple invitees: show first name + count
    const first = appointment.invitees[0];
    return `${first.firstName} ${first.lastName} +${appointment.invitees.length - 1}`;
  }
  // Legacy format: use root fields
  if (appointment.firstName && appointment.lastName) {
    return `${appointment.firstName} ${appointment.lastName}`;
  }
  return "Appointment";
};

export const MapToEvents = appointments => {
  return appointments.map(appointment => {
    const isPastEvent = isPast(appointment.date);
    const inviteeName = getInviteeName(appointment);
    const timeStr = appointment.source === "web"
      ? getTime(appointment.date)
      : getOnlyTime(appointment.date);
    return {
      ...appointment,
      id: appointment._id,
      start: moment(appointment.date).toDate(),
      end: moment(appointment.date).add(1, "hours").toDate(),
      title: `${inviteeName} ${timeStr}`,
      isCompleted: !appointment.isMissed && isPastEvent,
      isInProgress:
        !appointment.isMissed && !appointment.isCancelled && !isPastEvent,
      status: getAppointmentStatus(appointment, isPastEvent)
    };
  });
};
